import { connect as reduxConnect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../actions/role';
import LocalStorage from '../components/LocalStorage/index';

export const initialState = {
  isActive:
    LocalStorage.getRole() !== 'NONE' && LocalStorage.getCampus() !== 'NONE',
  roleType: LocalStorage.getRole(),
  campusType: LocalStorage.getCampus()
};

const reducer = (state = initialState, action) => {
  if (action.type === actions.types.ON_CHANGE_ROLE) {
    if (action.roleType === 'NONE') {
      //   return Object.assign({}, state, {
      //     isActive: false,
      //     roleType: action.roleType
      //   });
      return {
        ...state,
        isActive: false,
        roleType: action.roleType
      };
    }

    // return Object.assign({}, state, {
    //   isActive: true,
    //   roleType: action.roleType
    // });

    return {
      ...state,
      isActive: state.campusType !== 'NONE' ? true : false,
      roleType: action.roleType
    };
  }

  if (action.type === actions.types.ON_CHANGE_CAMPUS) {
    if (action.campusType === 'NONE') {
      //   return Object.assign({}, state, {
      //     isActive: false,
      //     campusType: action.campusType
      //   });

      return {
        ...state,
        isActive: false,
        campusType: action.campusType
      };
    }

    // return Object.assign({}, state, {
    //     isActive: true,
    //     campusType: action.campusType
    //   });

    return {
      ...state,
      isActive: state.roleType !== 'NONE' ? true : false,
      campusType: action.campusType
    };
  }

  return state;
};

const mapStateToProps = ({ role }) => ({
  role
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onChangeRole: actions.onChangeRole,
      onChangeCampus: actions.onChangeCampus
    },
    dispatch
  );
const connect = component =>
  reduxConnect(mapStateToProps, mapDispatchToProps)(component);

export default {
  actions,
  connect,
  reducer
};



// WEBPACK FOOTER //
// ./src/reducers/role.js